import { Color, DefaultValue, getDefaultTransition, pxToNumber, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface DraggableItemWrapperProps {
  dragging?: boolean
}

export const DraggableItemWrapper = styled.div<DraggableItemWrapperProps>`
  position: relative;
  /* Bug workaround https://github.com/atlassian/react-beautiful-dnd/issues/1881#issuecomment-1652549194 */
  left: auto !important;

  ${({ dragging }) =>
    dragging &&
    css`
      opacity: 0.75;

      /* Overlay */
      &:after {
        content: '';
        border: 1px solid ${Color.Grey100};
        border-radius: ${DefaultValue.BorderRadius};
        position: absolute;
        top: ${Spacing.S4};
        right: -${Spacing.S24};
        bottom: -${Spacing.S4};
        left: -${Spacing.S24};
        z-index: -1;
        background: ${Color.White};
      }
    `}
`

const DRAG_ZONE_SPACING = pxToNumber(Spacing.S24) - pxToNumber(Spacing.S4)

interface DragZoneProps {
  showOnHover?: boolean
}

export const DragZone = styled.div<DragZoneProps>`
  display: flex;
  position: absolute;
  top: ${DRAG_ZONE_SPACING}px;
  left: -${DRAG_ZONE_SPACING}px;

  ${({ showOnHover }) =>
    showOnHover &&
    css`
      opacity: 0;
      ${getDefaultTransition('opacity')};

      ${DraggableItemWrapper}:hover & {
        opacity: 1;
      }
    `}
`
